import React from "react";
import {
  FacebookLogo,
  InstagramLogo,
  WhatsappLogo,
  TelegramLogo,
  LinkedinLogo,
} from "phosphor-react";

/**
 * Social links for the login screens.
 *
 * Icons are rendered as local SVG (phosphor-react, already a dependency) —
 * previously these were Font Awesome glyphs pulled from cdnjs.cloudflare.com,
 * which is unreliable behind restrictive networks and was loaded without a
 * Subresource Integrity hash. The app now fetches no third-party assets.
 */

// Phosphor has no X logo, so this one is inlined (official X mark path).
const XLogo = ({ size = 20, weight, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
  </svg>
);

const LINKS = [
  { href: "https://www.facebook.com/web_erz", label: "Facebook", Icon: FacebookLogo },
  { href: "https://www.instagram.com/web_erz/", label: "Instagram", Icon: InstagramLogo },
  { href: "https://wa.me/+447456443839", label: "WhatsApp", Icon: WhatsappLogo },
  { href: "https://x.com/web_erz", label: "Twitter (X)", Icon: XLogo },
  { href: "https://telegram.me/web_erz", label: "Telegram", Icon: TelegramLogo },
  { href: "https://www.linkedin.com/in/web_erz", label: "LinkedIn", Icon: LinkedinLogo },
];

const SocialLinks = ({ className = "", iconSize = 20, linkClassName = "" }) => (
  <div className={`flex space-x-4 ${className}`}>
    {LINKS.map(({ href, label, Icon }) => (
      <a
        key={label}
        href={href}
        target="_blank"
        rel="noreferrer"
        aria-label={label}
        className={
          linkClassName ||
          "text-neutral-300 hover:text-white transition-colors"
        }
      >
        <Icon size={iconSize} weight="fill" />
        <span className="sr-only">{label}</span>
      </a>
    ))}
  </div>
);

export default SocialLinks;
